import { Props } from './index';
import './style.scss';
import dayjs from 'dayjs';
import { VFC, useEffect, useState } from 'react';
import DatePicker from 'react-mobile-datepicker';

export const WheelDatePicker: VFC<Props> = ({
  date: value,
  isDefault,
  isOpen,
  defaultDate,
  min,
  max,
  onSelect,
  onCancel,
  onChange,
}) => {
  const [date, setDate] = useState(value);
  const [isCallbackOnChange, setIsCallbackOnChange] = useState(false);

  useEffect(() => {
    if (!isCallbackOnChange) {
      setIsCallbackOnChange(true);
    } else {
      onChange(date);
    }
  }, [date]);

  useEffect(() => {
    if (isOpen) {
      const datePickerButtons = Array.from(
        document.getElementsByClassName('datepicker-navbar-btn'),
      ) as HTMLElement[];
      datePickerButtons.forEach((button) => {
        switch (button.textContent) {
          case '決定':
            button.style.color = isDefault ? '#CACACA' : '#ff66c4';
            break;
          default:
            button.style.color = '#ff66c4';
        }
      });
    }
  }, [isOpen, isDefault]);

  return (
    <DatePicker
      isOpen={isOpen}
      value={date}
      confirmText="決定"
      cancelText="リセット"
      customHeader={
        <p className="datepicker-header">{isDefault ? '未選択' : dayjs(date).format('YYYY/M/D')}</p>
      }
      min={min}
      max={max}
      onSelect={onSelect}
      onCancel={() => {
        onCancel();
        setDate(defaultDate);
        setIsCallbackOnChange(false);
      }}
      onChange={(date) => setDate(date)}
    />
  );
};
